module.exports = __webpack_public_path__ + "static/media/example04-03.1a7faec6.svg";